export default "__VITE_ASSET__CJHAB6xg__"